import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth';

const initialState = {
  selectedLtiDeepLink: undefined,
};

const ltiSlice = createSlice({
  name: 'lti',
  initialState,
  reducers: {
    setSelectedLtiDeepLink: (state, action) => {
      state.selectedLtiDeepLink = action.payload;
    },
    clearSelectedLtiDeepLink: (state) => {
      state.selectedLtiDeepLink = undefined;
    },
  },
  extraReducers: {
    [logout]: () => initialState,
  },
});

/**
 * @returns {{packages: {url: string, title: string, packageId?: string}[], time: number} | undefined} state.lti.selectedLtiDeepLink
 */

export const getSelectedLtiDeepLink = (state) => state.lti.selectedLtiDeepLink;

export const { setSelectedLtiDeepLink, clearSelectedLtiDeepLink } =
  ltiSlice.actions;

export default ltiSlice.reducer;
